module.exports = __webpack_public_path__ + "img/zhizhao.236d189f.jpg";